/* Text correction scoped to the observed related widget. */
(function () {
  'use strict';
  const selector = '[data-rebuy-id="242553"] .rebuy-product-block .subscription-checkbox .rebuy-checkbox-label';
  const zeroLabel = /^Upgrade to Subscription\s+(?:and|&)\s+Save\s+0(?:\.0+)?\s*%$/i;
  function correct() {
    for (const label of document.querySelectorAll(selector)) {
      const text = label.querySelector('.checkbox-label');
      const input = label.querySelector('input.rebuy-checkbox[type="checkbox"]');
      if (!text || !input) continue;
      const zero = zeroLabel.test(text.textContent.trim());
      if (zero) text.textContent = 'Subscribe';
      const name = input.getAttribute('aria-label');
      if (!name || (!zero && text.textContent.trim() !== 'Subscribe')) continue;
      const plain = name.replace(/<[^>]*>/g, '').replace(/&amp;/gi, '&').replace(/&nbsp;/gi, ' ');
      const corrected = plain.replace(/Upgrade to Subscription\s+(?:and|&)\s+Save\s+0(?:\.0+)?\s*%\s*$/i, 'Subscribe');
      if (corrected !== plain && corrected !== name) input.setAttribute('aria-label', corrected);
    }
  }
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; correct(); });
  });
  correct();
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
})();
